import { render, staticRenderFns } from "./PaymentMethodSelector.vue?vue&type=template&id=5397fb68&scoped=true"
import script from "./PaymentMethodSelector.vue?vue&type=script&lang=js"
export * from "./PaymentMethodSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397fb68",
  null
  
)

export default component.exports